import { Query, Mutation } from '@/generated/graphql';
import { ApolloClient, gql } from '@apollo/client/core';
import * as User from './User';

const USER_QUERY = gql`
  query users($userId: Int){
    app {
      users(userId: $userId) {
        id
        name
        email
      }
    }
  }
`;

export const fetchUser = async (client: ApolloClient<Query>, userId: number) => {
  const { data } = await client.query({
    query: USER_QUERY,
    variables: { userId },
    fetchPolicy: 'network-only',
  });

  return User.fromGql(data.app.users[0]);
};

const SAVE_USER_MUTATION = gql`
  mutation SaveUser($user: UserAttributes!){
    app {
      saveUser(input: { user: $user }) {
        user {
          id
          name
          email
        }
        errors
      }
    }
  }
`;

export const saveUser = async (client: ApolloClient<Mutation>, user: User.User) => {
  const { data } = await client.mutate({
    mutation: SAVE_USER_MUTATION,
    variables: {
      user: {
        id: user.id,
        name: user.name,
        email: user.email,
      },
    },
  });

  if (data.app.saveUser.errors) {
    return { errors: data.app.saveUser.errors };
  }

  return { user: User.fromGql(data.app.saveUser.user) };
};
